import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import { useLoginMutation } from '@jetshop/core/hooks/useLoginMutation';
import validate from './logInValidator';
import t from '@jetshop/intl';
import { useLoginRedirect } from '@jetshop/core/hooks/useLoginRedirect';
import { Redirect } from 'react-router';
import useAuth from '@jetshop/core/components/AuthContext/useAuth';
import { useShopConfig } from '@jetshop/core/hooks/useShopConfig';
import { trackLoginEvent } from '@jetshop/core/analytics/tracking';
import { useTracker } from '@jetshop/core/analytics/Analytics';
const LogInFormProvider = ({ children, redirect, initialEmail = '' }) => {
    const { getRedirectUrl } = useLoginRedirect();
    const { loggedIn } = useAuth();
    const { loginMutation } = useLoginMutation();
    const { routes } = useShopConfig();
    const track = useTracker();
    const [disabledByTimeout, setDisabledByTimeout] = useState(false);
    function triggerLoginFailed(globalError) {
        if (!globalError)
            return;
        const unableToLoginCustomerError = globalError.find(({ extensions }) => extensions.code === 'UnableToLoginCustomer');
        const timeOutLength = unableToLoginCustomerError === null || unableToLoginCustomerError === void 0 ? void 0 : unableToLoginCustomerError.extensions.data.tryAgainIn;
        if (timeOutLength) {
            setDisabledByTimeout(true);
            setTimeout(() => {
                setDisabledByTimeout(false);
            }, timeOutLength);
        }
    }
    redirect = redirect ? redirect : routes.myPages.path;
    return (React.createElement(Formik, { validate: validate, initialValues: {
            email: initialEmail,
            password: ''
        }, onSubmit: (values, actions) => {
            loginMutation({
                variables: values
            }).then(() => {
                // Track user login in GTAG
                track(trackLoginEvent());
                const returnUrlPromise = getRedirectUrl();
                if (returnUrlPromise) {
                    returnUrlPromise.then(returnUrl => {
                        if (returnUrl) {
                            window.location.href = returnUrl;
                        }
                        else {
                            actions.setSubmitting(false);
                        }
                    });
                }
                else {
                    actions.setSubmitting(false);
                }
            }, error => {
                actions.setSubmitting(false);
                actions.setErrors(error);
                actions.setStatus({
                    globalError: t('Login failed. Please try again')
                });
                triggerLoginFailed(error.graphQLErrors);
            });
        }, render: props => {
            var _a;
            return (React.createElement(React.Fragment, null,
                !props.isSubmitting && loggedIn && React.createElement(Redirect, { to: redirect }),
                React.createElement(Form, null, children(Object.assign(Object.assign({}, props), { isValid: !disabledByTimeout || props.isValid, globalError: (_a = props === null || props === void 0 ? void 0 : props.status) === null || _a === void 0 ? void 0 : _a.globalError })))));
        } }));
};
export default LogInFormProvider;
//# sourceMappingURL=LogInFormProvider.js.map